import React from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Section } from '@wds/section';

import PropTypes from 'prop-types';

const CardTemplate = (props) => {
	const { cardTitle, id, addOn, children } = props;

	return (
		<Box id={id} aria-label={id} className='sma-card-content' role='region'>
			<Box className='cardTitle' my={2} py={3} role='heading'>
				<Typography variant='sectionTitle' aria-label={cardTitle}>{cardTitle}</Typography>
			</Box>
			<Section
				addOn={addOn}
			>
				<Box role='region'>
					{children}
				</Box>
			</Section>
		</Box>
	);
};

CardTemplate.propTypes = {
	cardTitle: PropTypes.string.isRequired,
	id: PropTypes.string,
	addOn: PropTypes.node,
	children: PropTypes.node.isRequired,
};
CardTemplate.defaultProps = {
	id: undefined,
	addOn: null,
};
export default CardTemplate;
